import { ISelectItem } from '@lla-platform/core/core-ui'
import { INew_TableFilterRule, New_TableOperator } from '@lla-platform/core/core-data-access'

export const LeadReceivedTimeItems: ISelectItem[] = [
  { label: '< 8 AM', value: '0' },
  { label: '8-10 AM', value: '8' },
  { label: '10-12 AM', value: '10' },
  { label: '12-2 PM', value: '12' },
  { label: '2-4 PM', value: '14' },
  { label: '4-6 PM', value: '16' },
  { label: '6 PM >', value: '18' }
]

export const LeadReceivedTimeBucketRanges: Record<string, INew_TableFilterRule[]> = {
  '0': [{ operator: New_TableOperator.LessThan, value: 8 }],
  '8': [
    { operator: New_TableOperator.GreaterThanOrEqual, value: 8 },
    { operator: New_TableOperator.LessThan, value: 10 }
  ],
  '10': [
    { operator: New_TableOperator.GreaterThanOrEqual, value: 10 },
    { operator: New_TableOperator.LessThan, value: 12 }
  ],
  '12': [
    { operator: New_TableOperator.GreaterThanOrEqual, value: 12 },
    { operator: New_TableOperator.LessThan, value: 14 }
  ],
  '14': [
    { operator: New_TableOperator.GreaterThanOrEqual, value: 14 },
    { operator: New_TableOperator.LessThan, value: 16 }
  ],
  '16': [
    { operator: New_TableOperator.GreaterThanOrEqual, value: 16 },
    { operator: New_TableOperator.LessThan, value: 18 }
  ],
  '18': [{ operator: New_TableOperator.GreaterThanOrEqual, value: 18 }]
}
